import { createConfigLoader } from './lib/ConfigLoader';
import config from './lib/presets/config';
import { IConfig } from './lib/presets/IConfig';
import main from './main';

config.rootUrl = 'https://www.yellowmap.de';
createConfigLoader({ ...config as IConfig });

main();
